export const WholesaleInquiryCategory = Object.freeze({
    small: Symbol('small'),
    medium: Symbol('medium'),
    big: Symbol('big'),
    wagon: Symbol('wagon'),
    suv: Symbol('suv'),
    premium: Symbol('premium'),
    van: Symbol('van'),
    truck: Symbol('truck'),
    camper_van: Symbol('camper_van'),
});

export function getCategoryText(category) {
    return {
        [WholesaleInquiryCategory.small]: 'Małe',
        [WholesaleInquiryCategory.medium]: 'Średnie',
        [WholesaleInquiryCategory.big]: 'Duże',
        [WholesaleInquiryCategory.wagon]: 'Kombi',
        [WholesaleInquiryCategory.suv]: 'SUV',
        [WholesaleInquiryCategory.premium]: 'Premium',
        [WholesaleInquiryCategory.van]: 'Van',
        [WholesaleInquiryCategory.truck]: 'Dostawcze',
        [WholesaleInquiryCategory.camper_van]: 'Kamper',
    }[WholesaleInquiryCategory[category]];
}